import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import TaskCompletionStepInfo from '../../TaskCompletionStepInfo';
import ComboBox from '../../../../../components/ComboBox';
import animator from '../../../../../helpers/animator';
import Animate from '../../../../../components/Animate';
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';  
import dataModel from '../../../../../models/DataModel';
import CompletionStepUtil from '../../../../../helpers/CompletionStepUtil/CompletionStepUtil';
import CopyCompletionStepPopout from '../../../../CopyCompletionStepPopout';
import fileTypeFormIcon from '../../../../../assets/images/forms-icon.svg';
import fileTypeQuestionIcon from '../../../../../assets/images/question-icon.svg';
import fileTypeCheckoff from '../../../../../assets/images/checkoff-icon.svg';
import revertIcon from '../../../../../assets/images/revert-arrow.svg';
import trashIcon from '../../../../../assets/images/trash.svg';
import naIndicator from '../../../../../assets/images/na-indicator.svg';
import yesIndicator from '../../../../../assets/images/yes-indicator.svg';
import noIndicator from '../../../../../assets/images/no-indicator.svg';
import { completion_criteria_root } from '../../../../../dao/CompletionCriteriaDAO';
import DataSource from '../../../../../dao/DataSource/DataSource';
import './TaskCompletionStep.scss';
import ImageTools from '../../../../../helpers/ImageTools';

export class TaskCompletionStep extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      expanded: false,
      expanding: false,
      contracting: false,
      displayCopyPopout: false,
    };

    this.stepFileTypesToFullNames = {
      none: 'Check-off',
      doc: 'Document (.doc/.docx)',
      pdf: 'PDF (.pdf)',
      jpg: 'Photographs (.jpg/.png/.webp)',
      xls: 'Spreadsheet (.xls/.xlsx/.xlsm)',
      mp4: 'Video (.mp4/.mov)',
      Other: 'Other',
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.getCompletionStepTypeOption = this.getCompletionStepTypeOption.bind(this);
    this.revertCompletionStep = this.revertCompletionStep.bind(this);
    this.handleCopyPopupOpen = this.handleCopyPopupOpen.bind(this);
    this.handleCopyPopupClose = this.handleCopyPopupClose.bind(this);
  }

  handleUpdateCompletionStep(completionStep, action, acData) {
    if (acData && !acData._isInternal) {
      this.csDataSource.get();
    }
    else {
      this.setState({ completionStep });
    }
  }

  handleUpdateTask(task, action, acData) {
    if (acData && !acData._isInternal) {
      this.taskDataSource.get();
    }
    else {
      this.setState({ task });
    }
  }
  
  componentDidMount() {
    const { task, completionStep } = this.props;
    this.csDataSource = new DataSource('CompletionCriterion', completionStep, completion_criteria_root, this.handleUpdateCompletionStep);
    this.csDataSource.get();
    if (task.status == 'pending_review' || task.status == 'pending_approval') {
      this.setState({ expanded: true });
    }

    this.taskDataSource = new DataSource('Task', task.id, { task: {} }, this.handleUpdateTask);
    this.taskDataSource.get();
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if((prevProps.expandAll == false && this.props.expandAll == true) || (prevProps.expandAll == true && this.props.expandAll == false)){
      if (this.props.expandAll) {
        this.setState({ expanding: true });
      } else {
        this.setState({ contracting: true, expanded: false });
      }
    }
    if(prevProps.completionStep.status != this.props.completionStep.status){
      this.csDataSource.get();
    }
  }

  getCompletionStepTypeOption() {
    const { completionStep } = this.state;

    if (completionStep.completion_type == 'boolean') {
      return 'Check-off';
    }
    else if (completionStep.completion_type == 'form') {
      return 'Form';
    }
    else if (completionStep.completion_type == 'inspection') {
      return 'Inspection';
    }
    else if (completionStep.requested_file_type) {
      return this.stepFileTypesToFullNames[completionStep.requested_file_type];
    }
    else {
      return null;
    }
  }

  handleArrowClick() {
    this.props.history.push({
      pathname: `/mobile/projects-tasks/task/${this.state.task.id}/completion_step/${this.state.completionStep.id}`,
      state: { userStepPermissions: this.props.userStepPermissions },
    });
  }

  handleExpansion() {
    if (!this.props.editing) {
      if (this.state.expanded) {
        this.setState({ contracting: true, expanded: false });
      } else {
        this.setState({ expanding: true });
      }
    }
  }

  handleExpandDone() {
    this.setState({ expanding: false, expanded: true });
  }

  handleContractDone() {
    this.setState({ contracting: false });
  }

  fixExtension(extension) {
    if (extension) {
      let markStart = extension.indexOf('?');
      if (markStart >= 0) {
        extension = extension.substring(0, markStart);
      }
    }
    return extension;
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (
      !this.dragging &&
      this.dragElement &&
      this.dragElement == element &&
      !this.dragObject
    ) {
      this.dragging = true;
      let bodyElement = document.body;
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = 0.8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.props.completionStep, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    if (this.props.handleDropping) {
      this.dragObject = null;
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.completionStep, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      if (this.props.handleDragging) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (this.props.handleDragging) {
      if (!this.dragging && e.which == 1) {
        if (
          (this.startX && Math.abs(this.startX - e.clientX) > 5) ||
          (this.startY && Math.abs(this.startY - e.clientY) > 5)
        ) {
          this.handleStartDrag(this.cardElement);
        }
      }
    }
  }

  revertCompletionStep() {
    const { completionStep } = this.state;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: 'Are you sure you want to revert ' + completionStep.name + '? Work has begun on this Completion Step. This action cannot be undone.',
      width: 320,
      height: 184,
      okButtonText: 'YES',
      handleOwnerOk: () => {
        this.analyticsLogger.logReversalEvent();
        this.csDataSource.performAction('revertCompletionCriterion', completionStep, true, true);
      },
    });
  }
  
  handleTitleEnter(){
    this.hoverTimer = setTimeout(() => {
      this.setState({ hover: true });
    }, 750);
  }

  handleTitleLeave(){
    this.handleClearHoverTimer();
    if(this.state.hover){
      this.setState({ hover: false });
    }
  }
  handleClearHoverTimer(){
    clearTimeout(this.hoverTimer);
  }

  // Copying a step creates a new completion step on the task, so it is gated on
  // the same permission as editing the task (admin / super user / non-vendor
  // editor). Standard users get canCompleteTask but not canEditTask, so they
  // never see the copy affordance - being the reviewer or assignee on the task
  // does not change that.
  canCopyCompletionStep() {
    const { permissions } = this.props;
    return !!(permissions && permissions.canEditTask);
  }

  handleCopyPopupOpen(e) {
    e.stopPropagation();
    if (!this.canCopyCompletionStep()) {
      return;
    }
    this.setState({ displayCopyPopout: true });
  }
  
  handleCopyPopupClose() {
    this.setState({ displayCopyPopout: false });
  }

  render() {
    const { editing, firstInList } = this.props;
    const { completionStep, task } = this.state;
    if (!completionStep || !task) {
      return null;
    }
    const { expanded, expanding, contracting, setOriginalHeight } = this.state;
    const statusObject = CompletionStepUtil.getStatusObject(completionStep);
    const canCopy = this.canCopyCompletionStep();
    const copyIcon = ImageTools.getCopyIcon('black');

    // handle props
    let typeImage = this.prevImage;
    if (completionStep.completion_type == 'boolean') {
      typeImage = fileTypeCheckoff;
    }
    else if (completionStep.completion_type == 'inspection') {
      typeImage = fileTypeQuestionIcon;
    }
    else if (completionStep.completion_type == 'form') {
      typeImage = fileTypeFormIcon;
    } 
    else if (completionStep.requested_file_type) {
      // NOTE: this will work around corrupted file extensions
      typeImage = ImageTools.getIconForFile(completionStep.requested_file_type);
      this.prevImage = typeImage;
    }

    let numComments = completionStep.comments
      ? completionStep.comments.length
      : 0;

    let navType = 
        expanded || setOriginalHeight ? (
          <div className="contractor" />
        ) : (
          <div className="expandor" />
        );

    let rightSide, revertButton;
    const selectedTypeOption = this.getCompletionStepTypeOption();

    //define revert button here
    if ((editing || this.props.isBuildOwner || (this.props.permissions && this.props.permissions.isSuperUser)) && (completionStep.completed_at || completionStep.rejected_at)) {
      revertButton = (
        <img className="revert-button" src={revertIcon} onClick={ this.revertCompletionStep } alt="revert-button" />
      );
    }

    let responseIndicator = null;
    if(completionStep.status === 'completed'){
      if (completionStep.response != null) {
        switch (completionStep.response) {
        case 'N/A':
          responseIndicator = naIndicator;
          break;
        case 'YES':
          responseIndicator = yesIndicator;
          break;
        case 'NO':
          responseIndicator = noIndicator;
          break;
        default:
          break;
        }
      } else if (completionStep.not_applicable) {
        responseIndicator = naIndicator;
      }
    }
    else{
      responseIndicator = null;
    }

    if (editing) {
      //in edit mode, show disabled type dropdown, revert button, and delete button
      rightSide = (
        <div className="right-side">
          <ComboBox disabled={true} defaultText={selectedTypeOption} options={[{}]} hasBorder={false} underlined={false} adjustHeight={true}
                noFocus={true}
                displayFontStyle={{ fontSize: '12px', fontStyle: 'italic' }} width={234}/>
          {revertButton}
          <img className="remove-button" src={trashIcon} onClick={ () => this.props.handleDeleteCompletionStep(this.state.completionStep) } alt="remove-button" />
        </div>
      );
    } //if build owner is true and the buile owner is in edit view, allow them access to the revertButton 
    else if (this.props.buildOwnerEditing && this.props.isBuildOwner) {
      rightSide = (        
          <div className="right-side">
            {revertButton}
          </div>
        );
    }
    else {
      rightSide = (
      <div
        className="right-side"
        onClick={this.handleExpandContract}
      >
        <img
          className="completion-step-type"
          src={typeImage}
          alt="completion step type"
        />
        {numComments > 0 ? (
          <div className="comment-indicator">
            <div className="comment-count">{numComments}</div>
          </div>
        ) : null}
        {responseIndicator ? (<img className="response-indicator" src={responseIndicator} alt="Response"/>) : null}
        {navType}
        {canCopy && (
          <img
            src={copyIcon}
            alt="copy"
            className='copy-button'
            onClick={this.handleCopyPopupOpen}
          />
        )}
      </div>
    );
    }

    // handle state
    let animate = null;
    if (expanding) {
      const element = document.getElementById('completion-step-' + completionStep.id);
      this.savedHeight = element.clientHeight ? element.clientHeight : element.scrollHeight;
      animate = (
        <Animate
          component_id={'completion-step-inner-container-' + completionStep.id}
          key={'shared-completion-step-container-expand-' + completionStep.id}
          property={{ height: { startVal: 0, endVal: this.savedHeight } }}
          duration={250}
          completionCallback={this.handleExpandDone}
        />
      );
    }
    else if (contracting) {
      animate = <Animate component_id={'completion-step-inner-container-' + completionStep.id}
        key={'shared-completion-step-container-contract-' + completionStep.id}
        property={{ height: { startVal: this.savedHeight, endVal: 0 } }} duration={250}
        completionCallback={this.handleContractDone} />;
    }

    let style = {};
    if (expanded) {
      style = { height: 'auto' };
    }
    else if (!contracting) {
      style = { height: 0 };
    }
    return (
      <div
        className={`shared-task-completion-step ${expanded ? 'shared-task-completion-step--expanded' : 'shared-task-completion-step--contracted'}`}
        id={this.props.id} ref={element => {
          this.cardElement = element;
        }}
      >
        {this.props.editing && this.props.enableDragDrop && (
          <div className="drag-handle"
            onMouseDown={this.handleMouseDown}
            onMouseUp={this.handleMouseUp}
            onMouseMove={this.handleMouseMove}>
          </div>
        )}
        {animate}

        {this.state.hover &&
          <div className='tool-tip' onMouseLeave={this.handleTitleLeave}>
            <div className={'tool-tip-status-indicator ' + statusObject.css}/>
            <div className='tool-tip-inner'>
              <div className='tool-tip-info'>
                <div className='tool-tip-name'>
                  {completionStep.name.toUpperCase()}
                </div>
                <div className={'tool-tip-status ' + statusObject.css}>
                  {statusObject.text}
                </div>
              </div>
              <img className="tool-tip-completion-step-type" src={typeImage} alt="completion step type" />
              {numComments > 0 ? (
                <div className="tool-tip-comment-indicator">
                  <div className="tool-tip-comment-count">{numComments}</div>
                </div>
              ) : null}
            </div>
          </div>
        }

        <div className={`completion-step-banner ${firstInList ? 'first' : ''}`} onClick={this.handleExpansion} onKeyPress={this.handleExpansion}>
          <div className={'completion-step-info ' + statusObject.css}>
            <div className="step-title" onMouseEnter={this.handleTitleEnter} onMouseLeave={!this.state.hover ? this.handleClearHoverTimer : null}>
              {completionStep.name.toUpperCase()}
            </div>
            <div className={'step-status ' + statusObject.css}>{!this.props.projectTemplate ? statusObject.text : ''}</div>
          </div>
          {rightSide}
        </div>
          <div 
            className="completion-step-inner-container" 
            style={style}
            id={'completion-step-inner-container-' + completionStep.id}
          >
            <TaskCompletionStepInfo 
              id={'completion-step-' + completionStep.id}
              editing={this.props.editing}
              pmCanEdit={this.props.pmCanEdit}
              project={this.props.project}
              projectTemplate={this.props.projectTemplate}
              task={task}
              completionStep={completionStep}
              setOverrideBackPath={this.props.setOverrideBackPath}
              status={statusObject.text}
              userStepPermissions={this.props.userStepPermissions}
            />
          </div>  
      {canCopy && (
        <CopyCompletionStepPopout
          handleClosePopup={this.handleCopyPopupClose}
          displayCopyPopout={this.state.displayCopyPopout}
          completionStep={completionStep}
        />
      )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = dispatch => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaskCompletionStep));



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/TaskCompletionStep/index.js